var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Ta bort")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,6.5H16.58v-2A1.58,1.58,0,0,0,15,2.92H9A1.58,1.58,0,0,0,7.42,4.5v2H5a.5.5,0,0,0-.5.5V8a.5.5,0,0,0,.5.5H6v10a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V8.5h1a.5.5,0,0,0,.5-.5V7A.5.5,0,0,0,19,6.5ZM9.58,5.58a.51.51,0,0,1,.5-.5h3.84a.51.51,0,0,1,.5.5V6.5H9.58ZM9.75,18.5a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5Zm3,0a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5Zm3,0a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1-.5-.5v-7a.5.5,0,0,1,.5-.5h.5a.5.5,0,0,1,.5.5Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.05dfda83.svg";
export { ForwardRef as ReactComponent };